/*
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: 用户相关信息
 * @Date: 2021-09-09 15:21:20
 * @LastEditTime: 2022-01-04 15:47:54
 */
import { getBalance } from "model/campaign"
import { hasUnread,getMineInfo, getUserActiveOpt, getReferralDetail, reSendMail,setContact ,eventTrack} from "model/mine"
import { post } from "utils/request.js"
import { Dialog, Notify } from "vant"

//发送邮箱验证
let alreadyActive = false
const sendMail = async (user) => {
  const re = await reSendMail({ mail: user.mail, lastUrl: '/wap', utm: null })
  if(re.data){
    if (re.data.msg && re.data.msg === 'Mail already verified') {
      alreadyActive = true
    } else {
      return await Dialog.alert({
        message: re.data.msg,
        type: 'warning'
      })
    }
  }
  return re
}


// 应用状态
const state = () => {
  return {
    balance: '', //余额
    mine: null, //登录人信息
    referralOpen: null, //活动信息
    activeOpt: null, //用户状态
    alreadySkipActive: false, //是否以及激活邮箱
    alreadySkipContact: false, //是否校验了联系地址
    clientActivity: {}
  };
};

// getters
const getters = {
  //金额格式化处理
  price: s => {
    const money = (s.balance / 100).toFixed(2) + ''
    return money.replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,')
  }
}
// 操作管理
const mutations = {
  //设置余额
  setBalance(s, payload) {
    s.balance = JSON.parse(JSON.stringify(payload))
  },
  //设置个人信息
  setMine(s, p) {
    s.mine = JSON.parse(JSON.stringify(p))
  },
  //设置用户状态
  setActiveOpt(s, p) {
    s.activeOpt = JSON.parse(JSON.stringify(p))
  },
  //设置活动信息
  setReferralOpen(s, p) {
    s.referralOpen = p
  },
  //设置激活邮箱
  setAlreadySkipActive(s, p) {
    s.alreadySkipActive = p
  },
  //设置联系地址
  setAlreadySkipContact(s, p) {
    s.alreadySkipContact = p
  },
  //设置活动
  setClientActivity(s, p) {
    s.clientActivity = p
  },
  //修改用户信息中的国家
  UPDATE_MINEINFO_REGION(s,p) {
    s.mine.region = p
  },
  setHasUnread(s, p) {
    s.hasUnread = p
  }
  //修改密码
  // SET_MINEINFO_PASSWORD(s, p) {
  //   s.mine.password = p
  // }
};
// 可异步操作
const actions = {
  async hasUnread(ctx) {
    const res = await hasUnread()
    if (res || res === false || res === 0) {
      ctx.commit('setHasUnread', res)
    }
  },
  // 获取余额
  async getBalance(ctx) {
    const res = await getBalance({
      currencyType: 'USD'
    })
    if (res) {
      ctx.commit('setBalance', res)
    }
  },

  //获取全局信息
  async getAllInfo(ctx) {
    const ps = []

    // 1.获取登录用户信息
    /* eslint-disable */
    if(!ctx.state.mine){
      ps.push(new Promise(async (r) => {
        const res = await getMineInfo()
        window.$mine = res
        ctx.commit('setMine', res)
        r()
      }))
    }

    //获取状态
    if (!ctx.state.activeOpt) {
      ps.push(new Promise(async (r,) => {
        const res = await getUserActiveOpt()
        ctx.commit('setActiveOpt', res)
        r()
      }))
    }

    //获取用户活动信息
    if (ctx.state.referralOpen === null) {
      ps.push(new Promise(async (r) => {
        const res = await getReferralDetail()
        ctx.commit('setReferralOpen', res.isOpen)
        r()
      }))
    }
    ps.push(new Promise(async(r, j) => {
      await ctx.dispatch('hasUnread')
      r()
    }))
    await Promise.all(ps)
  },

  // 触发激活检查 ,resolve表示通过检查，reject表示没通过
  async triggerActive(ctx) {
    return new Promise(async (r, j) => {
      const user = ctx.state.mine
      // 用户已经激活
      if (user.state === 1) {
        r()
        return
      }
      // 如果关闭 或者 （可跳过，且已经跳过了激活），则直接检查联系方式
      const activeKey = ctx.state.activeOpt.ORDER_ACTIVE_KEY
      if (activeKey === 'CLOSE' || (activeKey === 'SKIPABLE' && ctx.state.alreadySkipActive)) {
        ctx.dispatch('triggerFillContact').then(() => {
          // 检查联系方式通过，整体通过
          r()
          return
        }).catch(() => {
          // 检查联系方式未通过
          j()
          return
        })
      } else {
        // 需要激活，先给他发激活邮件
        const res=await sendMail(user)
        // 这里无论是否发送成功，都要继续，弹窗，因为可能退出或重发
        if (alreadyActive) {
          return
        }
        
        try {
          Dialog.confirm({
            closeOnClickOverlay :true,
            title: 'Please Active Your Account',
            message: `<div>We have already sent you an email to "<b>${user.mail}</b>" and please follow the instruction to activate your account. If you have not received the activation email, please check the spam mailbox or click "<b>Resend</b>".</div>`,
            showCancelButton: true,
            confirmButtonText: 'Resend',
            cancelButtonText: 'Skip',
            allowHtml: true,
            beforeClose: async (action) => {
     
              if (action === 'confirm') {
                //发送邮箱校验
                let re = await sendMail(user)
                if (re) {
                  Notify ({
                    type: 'success', message: 'send success'
                  })
                 r()
                }else{
                  Notify ({
                    type: 'danger', message: 'send fail'
                  })
                  j()
                }
          
              } else if (action === 'cancel') {
                ctx.commit('setAlreadySkipActive', true)
                // 检查联系方式通过，整体通过
                ctx.dispatch('triggerFillContact').then(() => {
                  r()
                  Dialog.close()
                }).catch(() => {
                  j()// 检查联系方式未通过
                })
              }else{
                Dialog.close()
              }
    
            }
          })
          
        } catch (error) {
          
        }



      }
    })
  },
  
  // 触发填写联系方式
  async triggerFillContact(ctx) {
    return new Promise(async (r,j) => {
      const user = ctx.state.mine
      if (user.contact) { // 已经有了联系方式
        r()
        return
      }
      const contactKey = ctx.state.activeOpt.ORDER_CONTACT_KEY
      if (contactKey === 'CLOSE') {
        r()
        return
      }
      if (contactKey === 'SKIPABLE' && ctx.state.alreadySkipContact) {
        r()
        return
      }

      Dialog.confirm({
        closeOnClickOverlay :true,
        title: 'Contact Information',
        message: `
        <div class='promt-input'>
        <label for='contact'>Contact</label>
        <input id='contact' placeholder="Your Contact Information"/>
        </div>
        <div class='promt-desc'>ASO World needs your contact information in order to track your order details.</div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Submit',
        cancelButtonText: 'Skip',
        allowHtml: true,
        beforeClose: async (action) => {
          if (action === 'confirm') {
            const value = document.getElementById('contact').value.trim()
            if(!value){
              Notify ({
                type: 'warning', message: 'Please Fill in Your Contact Information'
              })
            }
            if(value){
              const re = await setContact({
                contact: value
              })
              if(re.code === 0){
                    r()
                    return
              }else{
                    j()
                    return
              }

            }
      
          } else if (action === 'cancel') {
            ctx.commit('setAlreadySkipContact', true)
            Dialog.close()
             r()
          }else{
            Dialog.close()
          }

        }
      })
    })
  },
  // 获取活动
  async getTempActivity(ctx) {
    const resp = await post('MyActivity/getTempActivity')

    if (resp.code===0 && resp.data) {
      const serviceTags = resp.data.activity.detail.serviceTags
      const serviceArr = resp.data.serviceType && new Array(resp.data.serviceType.length + 1).fill('') || []
      for (let i = 0; i < serviceTags.length; i++) {
        for (let j = 0; j < serviceTags[i].module.length; j++) {
          serviceArr[serviceTags[i].module[j]] = serviceTags[i].tags
        }
      }
      ctx.commit('setClientActivity', { ...resp.data.activity, serviceArr })
    }
  },
  // 前端埋点
  async dataTrack( ctx,payload) {
    await eventTrack(payload)
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
